import { Component, ElementRef, Input, OnDestroy, OnInit, EventEmitter, Renderer2, forwardRef, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';

const noop = () => {};

export const CUSTOM_FMCHECKBOX_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormCheckBoxComponent),
  multi: true
};

@Component({
  selector: 'fm-checkbox',
  templateUrl: 'form-checkbox.component.html',
  styles: [`
  .label {
    margin-left: 20px;
    padding-top: 4px;
  }
  `],
	providers: [CUSTOM_FMCHECKBOX_CONTROL_VALUE_ACCESSOR]
})
export class FormCheckBoxComponent extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService,
  ) { 
    super(); 
  }
  
  @Input() resetBtn: boolean = true;
  @Input() label = "";
  tabindex: string;
  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }

  @Input() disabled: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  
  private numOfTabs: number = 0;
  private innerValue: boolean;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));

    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
  }

  ngOnDestroy() {
  }

  resetValue(event: any): void {
    this.writeValue(event);
    this.onChangeCallback(event);
  }

  get value(): any {
    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
      this.onClickCallback(v);
    }
  }

   onChange(obj: { originalEvent: Event; value: boolean }) {
    if (obj.value !== this.innerValue) {
      this.writeValue(obj.value);
      this.onChangeCallback(obj.value);
      this.onClickCallback(event);
    }
  }

  onClickCallback(event: object) {
    this.onClick.emit(event);
  }

  onLabelClick() {
    if (!this.disabled){
      this.value = !this.value;
    }
  }
  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
